import React from 'react'

import { Security } from '@okta/okta-react'

import { oktaAuth } from '../lib/authentication'

const OktaSecurity = ({ children }) => (
  <Security auth={oktaAuth}>
    { children }
  </Security>
)

export default OktaSecurity
